import { NgModule } from '@angular/core';
import { SharedComponentsModule } from '../../shared/module/shared-components.module';
import { RemindersComponent } from '../component/base/reminders.component';
import { ReminderFormComponent } from '../component/reminders-modal-form/reminder-form.component';
import {
  ButtonDropDownSingleComponent,
} from '../component/button-drop-down-single/button-drop-down-single.component';
import {
  TableGroupIconComponent,
} from "../../shared/component/icons-deprecated/table-group-icon/table-group-icon.component";

@NgModule({
  declarations: [
    RemindersComponent,
    ReminderFormComponent,
    ButtonDropDownSingleComponent,
  ],
  imports: [
    SharedComponentsModule,
    TableGroupIconComponent,
  ],
  exports: [
    RemindersComponent,
  ],
})

export class RemindersModule {
}
